import React from 'react'
import styles from './styles.module.scss'

interface WhatIsIrresponsibleLendingProps {
    onScrollToForm: () => void
}

export const WhatIsIrresponsibleLending: React.FC<WhatIsIrresponsibleLendingProps> = ({ onScrollToForm }) => {
    return (
        <section className={styles.infoSection}>
            <div className={styles.container}>
                <div className={styles.sectionHeader}>
                    <h2>What is Irresponsible Lending?</h2>
                    <p>Understanding your rights when it comes to car finance agreements</p>
                </div>
                <div className={styles.cardGrid}>
                    <div className={styles.card}>
                        <div className={styles.cardIcon}>
                            <span>📋</span>
                        </div>
                        <h3>Inadequate Affordability Checks</h3>
                        <p>Lenders failed to properly assess your income, expenses, and ability to repay the loan.</p>
                    </div>
                    <div className={styles.card}>
                        <div className={styles.cardIcon}>
                            <span>⚠️</span>
                        </div>
                        <h3>Unsuitable Products</h3>
                        <p>You were sold a finance product that didn't match your financial circumstances or needs.</p>
                    </div>
                    <div className={styles.card}>
                        <div className={styles.cardIcon}>
                            <span>📄</span>
                        </div>
                        <h3>Insufficient Information</h3>
                        <p>Important terms and conditions weren't properly explained or were hidden in small print.</p>
                    </div>
                </div>
                <div className={styles.ctaCenter}>
                    <button className={styles.ctaButton} onClick={onScrollToForm}>
                        Start Your Free Assessment
                    </button>
                </div>
            </div>
        </section>
    )
}
